/**
 * contentにblockがあるか確認
 * @param {*} content
 */
export function hasBlock(content) {
  return content && Object.keys(content?.blocks ?? {}).length > 0;
}
